import { Typography } from "@mui/material";
import { CardTransactionItem } from "Components/CardTransactions/CardTransactionItem";
import { CardTransactionSkeletons } from "Components/CardTransactions/CardTransactionSkeletons";
import type { CardTransactionItem as CardTransactionItemType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Components.CardTransactions;

type Props = {
  transactions: Array<CardTransactionItemType>;
  isLoading: boolean;
  skeletonCount: number;
};

export const CardTransactionsListContent = ({
  transactions,
  isLoading,
  skeletonCount,
}: Props) => {
  const { t } = useResource();

  if (isLoading) {
    return <CardTransactionSkeletons count={skeletonCount} />;
  }

  if (transactions.length === 0) {
    return (
      <Typography marginTop={({ spacing }) => spacing(2)}>
        {t(PageResources.NoCardTransactions)}
      </Typography>
    );
  }

  return transactions.map((transaction) => (
    <CardTransactionItem key={transaction.publicID} item={transaction} />
  ));
};
